import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import Login from "../pages/login-forms/login/index.vue"
import AppSelection from "../pages/AppSelection.vue";
import Dashboard from "@/pages/Dashboard.vue";
import su1Details from "../pages/surveys/components/su1Details.vue";
import su2Details from "../pages/surveys/components/su2Details.vue";
import su2Questions from "../pages/surveys/components/Su2Questions.vue";
import Stakeholders from "../pages/usersStakeholders/index.vue";
import RegisterForm from "../pages/login-forms/registerform/index.vue";
import RegisterPass from "../pages/login-forms/registerpass/index.vue";
import PasswordReset from "../pages/login-forms/passwordReset/index.vue";
import PasswordUpdate from "../pages/login-forms/passwordUpdate/index.vue";
import SurveyComponent from "../pages/surveys/components/SurveyComponent.vue";
import Su1Survey from "../pages/surveys/components/su1SurveyParentComponent.vue";
import registerCompany from "../pages/register/registerCompany.vue";
import su1Surveys from "../pages/surveys/components/Su1Surveys.vue";
import su2Surveys from "../pages/surveys/components/Su2Surveys.vue";
import Reports from "../pages/reports/index.vue";
import SectionGeneration from "../pages/sectionGeneration/index.vue";
import Company from "../pages/company/index.vue";
import MyCompanies from "../pages/myCompanies/index.vue";
import Su1Results from "../pages/results/components/su1Results.vue";
import Su2Results from "../pages/results/components/su2Results.vue";
import ProjectSearchEngine from "../pages/projectSearchEngine/index.vue";
import Documents from "../pages/documents/index.vue";
import SupplierMetrics from "../pages/supplierMetrics/index.vue";
import KPIsMetrics from "../pages/KPIsMetrics/index.vue";
import KpiMonitoring from "../pages/KPIsMetrics/KpiMonitoring.vue";
import AdminPanel from "../pages/adminPanel/index.vue";
import PageNotFound from "@/pages/PageNotFound.vue";
import UnderMaintenance from "../pages/UnderMaintenance.vue";
import registerComplete from "../pages/register/registerComplete.vue";
import companyLinking from "../pages/company/dynamic/companyLinking.vue";
import TestScene from "../pages/TestScene.vue";
import AuditedCompanies from "../pages/myCompanies/AuditedCompanies.vue";
import AuditorKpis from "../pages/auditor/kpis.vue";
import AuditSu1Results from "../pages/auditor/su1Results.vue";
import AuditSu2Results from "../pages/auditor/su2Results.vue";
import AuditReports from "../pages/auditor/reports.vue";
import CompanyProfile from "../pages/auditor/companyProfile.vue";
import UserProfile from "../pages/adminPanel/components/userProfile.vue";
import MetricAssignments from "../pages/adminPanel/components/metricAssignments.vue";
import SupplierMetricRequests from "../pages/adminPanel/components/supplierMetricRequests.vue";
import RequestedMetrics from "../pages/requestedMetrics/index.vue";
import CarbonAssignments from "../pages/adminPanel/components/carbonAssignments.vue";
import PermissionsPage from "../pages/adminPanel/components/permissionsPage.vue";
import CompanyInformation from "../pages/adminPanel/components/companyProfile.vue";
import AllCompanies from "../pages/adminPanel/components/allCompanies.vue";
import LogsPage from "../pages/adminPanel/components/logsPage.vue";
import CarbonProfile from "../pages/adminPanel/components/carbonProfile.vue";
import CompanyLicences from "../components/CompanyLicence.vue";
import SustTables from "../pages/additionalSettings/components/helper/SustTables.vue";
import Prompts from "../pages/additionalSettings/components/prompts.vue";
import AppState from "../pages/additionalSettings/components/appState.vue";
import Metrics from "../pages/additionalSettings/components/metrics/index.vue";
import TeamMembers from "../pages/adminPanel/components/teamMembers.vue";
import IsoCategories from "../pages/additionalSettings/carbonComponents/iso-categories.vue";
import IsoSubCategories from "../pages/additionalSettings/carbonComponents/iso-sub-categories.vue";
import HotelStayFactors from "../pages/additionalSettings/carbonComponents/hotel-stay-factors.vue";
import ElectricFactors from "../pages/additionalSettings/carbonComponents/electric-factors.vue";
import GwpGroups from "../pages/additionalSettings/carbonComponents/gwp-groups.vue";
import GwpFactors from "../pages/additionalSettings/carbonComponents/gwp-factors.vue";
import IsoSectors from "../pages/additionalSettings/carbonComponents/iso-sectors.vue";
import CombustionTypes from "../pages/additionalSettings/carbonComponents/combustion-types.vue";
import MobilityTypes from "../pages/additionalSettings/carbonComponents/mobility-types.vue";
import CombustionCategories from "../pages/additionalSettings/carbonComponents/combustion-categories.vue";
import CombustionFactors from "../pages/additionalSettings/carbonComponents/combustion-factors.vue";
import RefrigerantFactors from "../pages/additionalSettings/carbonComponents/refrigerant-factors.vue";
import EpaSectors from "../pages/additionalSettings/carbonComponents/epa-sectors.vue";
import EpaFactors from "../pages/additionalSettings/carbonComponents/epa-factors.vue";
import DefraScopes from "../pages/additionalSettings/carbonComponents/defra-scopes.vue";
import DefraCategories from "../pages/additionalSettings/carbonComponents/defra-categories.vue";
import DefraActivities from "../pages/additionalSettings/carbonComponents/defra-activities.vue";
import DefraTypes from "../pages/additionalSettings/carbonComponents/defra-types.vue";
import DefraFuels from "../pages/additionalSettings/carbonComponents/defra-fuels.vue";
import DefraUnits from "../pages/additionalSettings/carbonComponents/defra-units.vue";
import DefraFactors from "../pages/additionalSettings/carbonComponents/defra-factors.vue";

/** @type {import('vue-router').Route[]} */
const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/apps",
    name: "apps",
    component: AppSelection,
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "dashboard",
        component: Dashboard,
        meta: {
          key: "route_names.dashboard"
        }
      },
      {
        path: '/sdg-survey-details',
        name: 'SDG Alignment Survey Details',
        component: su1Details,
        meta: {
          key: "route_names.su1_details"
        }
      },
      {
        path: '/materiality-analysis-survey-details',
        name: 'Materiality Analysis Survey Details',
        component: su2Details,
        meta: {
          key: "route_names.su2_details"
        }
      },
      {
        path: '/materiality-analysis-survey-questions',
        name: 'Materiality Analysis Survey Questions',
        component: su2Questions,
        meta: {
          key: "route_names.su2_questions"
        }
      },
      {
        path: '/materiality-analysis-surveys',
        name: 'Materiality Analysis Surveys',
        component: su2Surveys,
        meta: {
          key: "route_names.su2_surveys"
        },
      },
      {
        path: '/sdg-alignment-surveys',
        name: 'SDG Alignment Surveys',
        component: su1Surveys,
        meta: {
          key: "route_names.su1_surveys"
        },
      },
      {
        path: '/stakeholders',
        name: 'User Operations',
        component: Stakeholders,
        meta: {
          key: "route_names.stakeholders"
        },
      },
      { 
        path: '/reports', /* 12 */
        name: 'Reports',
        component: Reports,
        meta: {
          key: "route_names.reports"
        }, 
      },
      {
        path: '/generate-sections',
        name: 'Generate Sections',
        component: SectionGeneration,
        meta: {
          key: "route_names.section_generation"
        },
      },
      {
        path: "/company",
        name: "Company",
        component: Company,
        meta: {
          key: "route_names.company"
        }
      },
      {
        path: "/my-companies",
        name: "My Companies",
        component: MyCompanies,
        meta: {
          key: "route_names.my_companies"
        }
      },
      {
        path: "/su1Results",
        name: "Su1 Results",
        component: Su1Results,
        meta: {
          key: "route_names.su1_results"
        }
      },
      {
        path: "/su2Results",
        name: "Su2 Results", // 18
        component: Su2Results,
        meta: {
          key: "route_names.su2_results"
        }
      },
      {
        path: "/kpi-metrics", 
        name: "KPIs & Metrics",
        component: KPIsMetrics,
        meta: {
          key: "route_names.kpis_metrics"
        }
      }, 
      {
        path: "/kpi-monitoring",
        name: "KPI Monitoring",
        component: KpiMonitoring,
        meta: {
          key: "route_names.kpi_monitoring"
        }
      },
      {
        path: "/requested-metrics",
        name: "Requested Metrics",
        component: RequestedMetrics,
        meta: {
          key: "route_names.requested_metrics"
        }
      },
      {
        path: "/project-search-engine", 
        name: "Project Search Engine",
        component: ProjectSearchEngine,
        meta: {
          key: "route_names.project_search_engine"
        } 
      },
      {
        path: "/documents",
        name: "Documents",
        component: Documents,
        meta: {
          key: "route_names.documents"
        }
      },
      {
        path: "/supplier-metrics",
        name: "Supplier Metrics",
        component: SupplierMetrics,
        meta: {
          key: "route_names.supplier_metrics"
        }
      },
      {
        path: "/admin-panel",
        name: "Admin Panel",
        component: AdminPanel,
        meta: {
          key: "route_names.admin_panel.title"
        },
        children: [
          {
            path: "additional-settings/app-state",
            name: "App State",
            component: AppState,
            meta: {
              key: "route_names.admin_panel.children.app_state"
            }
          },
          {
            path: "additional-settings/metrics",
            name: "Metrics",
            component: Metrics,
            meta: {
              key: "route_names.admin_panel.children.metrics"
            }
          },
          {
            path: "user-profile",
            name: "User Profile",
            component: UserProfile,
            meta: {
              key: "route_names.admin_panel.children.user_profile"
            },
          },
          {
            path: "team-members",
            name: "Team Members",
            component: TeamMembers,
            props: true,
            meta: {
              key: "route_names.admin_panel.children.team_members"
            },
          },
          {
            path: "metric-assignments",
            name: "Metric Assignments",
            component: MetricAssignments,
            meta: {
              key: "route_names.admin_panel.children.metric_assignments"
            },
          },
          {
            path: "supplier-metric-requests",
            name: "Supplier Metric Requests",
            component: SupplierMetricRequests,
            meta: {
              key: "route_names.admin_panel.children.supplier_metric_requests"
            },
          },
          {
            path: "carbon-assignments",
            name: "Carbon Assignments",
            component: CarbonAssignments,
            meta: {
              key: "route_names.admin_panel.children.carbon_assignments"
            },
          },
          {
            path: "company-information",
            name: "Company Information",
            component: CompanyInformation,
            meta: {
              key: "route_names.admin_panel.children.company_information"
            },
          },
          {
            path: "permissions",
            name: "Permissions",
            component: PermissionsPage,
            meta: {
              key: "route_names.admin_panel.children.permissions_page"
            },
          },
          {
            path: "all-companies",
            name: "All Companies (Admin)",
            component: AllCompanies,
            meta: {
              key: "route_names.admin_panel.children.all_companies"
            },
          },
          { 
            path: "logs",
            name: "Logs",
            component: LogsPage,
            meta: {
              key: "route_names.admin_panel.children.logs"
            },
          },
          {
            path: "carbon-profile",
            name: "Carbon Profile",
            component: CarbonProfile,
            meta: {
              key: "route_names.admin_panel.children.carbon_profile"
            },
          },
          {
            path: "licence",
            name: "Company Licence",
            component: CompanyLicences,
            meta: {
              key: "route_names.admin_panel.children.licence"
            },
          },
          {
            path: "additional-settings",
            name: "Additional Settings",
            component: SustTables,
            meta: {
              key: "route_names.admin_panel.children.additional_settings"
            }
          },
          {
            path: "additional-settings/prompts",
            name: "Prompts",
            component: Prompts,
            meta: {
              key: "route_names.admin_panel.children.prompts"
            }
          },
          {
            path: "additional-settings/iso-categories",
            name: "ISO Categories",
            component: IsoCategories,
            meta: {
              key: "route_names.admin_panel.children.iso-categories"
            }
          },
          {
            path: "additional-settings/iso-sub-categories",
            name: "ISO Sub Categories",
            component: IsoSubCategories,
            meta: {
              key: "route_names.admin_panel.children.iso-sub-categories"
            }
          },
          {
            path: "additional-settings/hotel-stay-factors",
            name: "Hotel Stay Factors",
            component: HotelStayFactors,
            meta: {
              key: "route_names.admin_panel.children.hotel-stay-factors"
            }
          },
          {
            path: "additional-settings/electric-factors",
            name: "Electric Factors",
            component: ElectricFactors,
            meta: {
              key: "route_names.admin_panel.children.electric-factors"
            }
          },
          {
            path: "additional-settings/gwp-groups",
            name: "GWP Groups",
            component: GwpGroups,
            meta: {
              key: "route_names.admin_panel.children.gwp-groups"
            }
          },
          {
            path: "additional-settings/gwp-factors",
            name: "GWP Factors",
            component: GwpFactors,
            meta: {
              key: "route_names.admin_panel.children.gwp-factors"
            }
          },
          {
            path: "additional-settings/iso-sectors",
            name: "ISO Sectors",
            component: IsoSectors,
            meta: {
              key: "route_names.admin_panel.children.iso-sectors"
            }
          },
          {
            path: "additional-settings/combustion-types",
            name: "Combustion Types",
            component: CombustionTypes,
            meta: {
              key: "route_names.admin_panel.children.combustion-types"
            }
          },
          {
            path: "additional-settings/mobility-types",
            name: "Mobility Types",
            component: MobilityTypes,
            meta: {
              key: "route_names.admin_panel.children.mobility-types"
            }
          },
          {
            path: "additional-settings/combustion-categories",
            name: "Combustion Categories",
            component: CombustionCategories,
            meta: {
              key: "route_names.admin_panel.children.combustion-categories"
            }
          },
          {
            path: "additional-settings/combustion-factors",
            name: "Combustion Factors",
            component: CombustionFactors,
            meta: {
              key: "route_names.admin_panel.children.combustion-factors"
            }
          },
          {
            path: "additional-settings/refrigerant-factors",
            name: "Refrigerant Factors",
            component: RefrigerantFactors,
            meta: {
              key: "route_names.admin_panel.children.refrigerant-factors"
            }
          },
          {
            path: "additional-settings/epa-sectors",
            name: "EPA Sectors",
            component: EpaSectors,
            meta: {
              key: "route_names.admin_panel.children.epa-sectors"
            }
          },
          {
            path: "additional-settings/epa-factors",
            name: "EPA Factors",
            component: EpaFactors,
            meta: {
              key: "route_names.admin_panel.children.epa-factors"
            }
          },
          {
            path: "additional-settings/defra-scopes",
            name: "DEFRA Scopes",
            component: DefraScopes,
            meta: {
              key: "route_names.admin_panel.children.defra-scopes"
            }
          },
          {
            path: "additional-settings/defra-categories",
            name: "DEFRA Categories",
            component: DefraCategories,
            meta: {
              key: "route_names.admin_panel.children.defra-categories"
            }
          },
          {
            path: "additional-settings/defra-activities",
            name: "DEFRA Activities",
            component: DefraActivities,
            meta: {
              key: "route_names.admin_panel.children.defra-activities"
            }
          },
          {
            path: "additional-settings/defra-types",
            name: "DEFRA Fuel / Vehicle Types",
            component: DefraTypes,
            meta: {
              key: "route_names.admin_panel.children.defra-types"
            }
          },
          {
            path: "additional-settings/defra-fuels",
            name: "DEFRA Fuels",
            component: DefraFuels,
            meta: {
              key: "route_names.admin_panel.children.defra-fuels"
            }
          },
          {
            path: "additional-settings/defra-units",
            name: "DEFRA Units",
            component: DefraUnits,
            meta: {
              key: "route_names.admin_panel.children.defra-units"
            }
          },
          {
            path: "additional-settings/defra-factors",
            name: "DEFRA Units",
            component: DefraFactors,
            meta: {
              key: "route_names.admin_panel.children.defra-factors"
            }
          },
        ]
      },
      {
        path: "/audited-companies",
        name: "Audited Companies",
        component: AuditedCompanies,
        meta: {
          key: "route_names.audited_companies"
        }
      },
      {
        path: "/audited-company-profile",
        name: "Audited Company Profile",
        component: CompanyProfile,
        meta: {
          key: "route_names.audited_company_profile"
        }
      },
      {
        path: "/audit-metrics",
        name: "Audit Metrics",
        component: AuditorKpis,
        meta: {
          key: "route_names.company_metrics"
        }
      },
      {
        path: "/audit-sdg-alignment",
        name: "Audit SDG Alignment",
        component: AuditSu1Results,
        meta: {
          key: "route_names.auditor_su1_results"
        }
      },
      {
        path: "/audit-materiality-analysis",
        name: "Audit Materiality Analysis",
        component: AuditSu2Results,
        meta: {
          key: "route_names.auditor_su2_results"
        }
      },
      {
        path: "/audit-reports",
        name: "Audit Reports",
        component: AuditReports,
        meta: {
          key: "route_names.auditor_reports"
        }
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      key: "route_names.login"
    }
  },
  {
    path: "/register_single",
    name: "registerForm",
    component: RegisterForm,
    meta: {
      key: "route_names.register_form"
    }
  },
  {
    path: "/register",
    name: "registerPass",
    component: RegisterPass,
    meta: {
      key: "route_names.register_pass"
    }
  },
  {
    path: "/passwordrecovery",
    name: "PasswordReset",
    component: PasswordReset,
    meta: {
      key: "route_names.password_reset"
    }
  },
  {
    path: "/passwordupdate",
    name: "PasswordUpdate",
    component: PasswordUpdate,
    meta: {
      key: "route_names.password_update"
    }
  },
  {
    path: "/materiality-analysis-survey",
    name: "surveyComponent",
    component: SurveyComponent,
    meta: {
      key: "route_names.survey_component"
    }
  },
  {
    path: "/sdg-alignment-survey",
    name: "su1Survey",
    component: Su1Survey,
    meta: {
      key: "route_names.su1_survey"
    }
  },
  {
    path: "/register-sustainfinity",
    name: "registerCompany",
    component: registerCompany,
    meta: {
      key: "route_names.register_sustainfinity"
    }
  },
  {
    path: "/register-complete",
    name: "registerComplete",
    component: registerComplete,
    meta: {
      key: "route_names.register_complete"
    }
  },
  {
    path: "/company-linking",
    name: "companyLinking",
    component: companyLinking,
    meta: {
      key: "route_names.sustainfinity_link"
    }
  },
  {
    path : '/under-maintenance',
    name : 'Maintenance',
    component: UnderMaintenance
  },
  {
    path : '*',
    component: PageNotFound
  },
  {
    path: "/test-scene",
    name: "test_page",
    component: TestScene,
  }

];

export default routes;